export default "https://cdn-static.gokick.com/assets/21dc595b281e80327dab5b97c944977d2420b47e/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";